import { app } from '../../../bootstrap/core';
import { documentSummaryComponent } from './documentSummary.component';
import './document/document';

app.component('documentSummary', documentSummaryComponent);
